<template lang="pug">
  .component-wallet-record-list(v-if="value")
    ActionBar
      h2(slot="title") Wallet records
      i.fa.fa-plus-circle.fa-2x(slot="action", v-if="expanded", @click="walletAddCostToggle = !walletAddCostToggle")
      i.fa.fa-2x(slot="action", :class="{'fa-eye-slash':expanded, 'fa-eye':!expanded}", @click="expanded = !expanded")
      ActionButton(slot="action", :button="false", :action="refreshList")
        span.fa.fa-refresh.fa-2x(style="color:white")

    .wallet(v-show="expanded")
      template(v-if="value.amounts['RECORDS_VATIN'] != value.amounts['BALANCE_VATIN']")
        h3 Current Balance: {{ $priceWithcurrency(value.amounts['RECORDS_VATIN']) }}
        span.small(v-if="value.amounts['UNINVOICED_RECORDS_VATIN'] !== '0.00'") (Inc. {{ $priceWithcurrency(value.amounts['UNINVOICED_RECORDS_VATIN']) }} of uninvoiced items)

      span.small(v-if="value.amounts['UNINVOICED_DEPOSITS_VATIN'] !== '0.00'") (Inc. {{ $priceWithcurrency(value.amounts['UNINVOICED_DEPOSITS_VATIN']) }} of uncredited deposits)
      wallet-add-cost(:wallet="value", v-if="walletAddCostToggle")
      .tabs-inner-content
        base-list(ref="wrList", :component="component", :dataLoader="dataLoader", :resultsPerPage="5", :search="search", component-type="multi-wallet")

</template>

<script>
    import BaseList from '../../../pages/backoffice/BaseList'
    import KeplerBackofficeSdk from '../../../lib/kepler/backoffice'
    import WalletAddCost from '../WalletAddCost'
    import ActionBar from '../../structure/ui/ActionBar'
    import ActionButton from '../../structure/ui/ActionButton'

    export default {
        name: 'BackofficeMultiWallet',
        components: {ActionButton, ActionBar, WalletAddCost, BaseList},
        data() {
            return {
                wallets: [],
                component: require('src/components/backoffice/WalletRecord.vue'),
                selectedWallet: 0,
                walletAddCostToggle: false,
                expanded: true,
                paymentMethods: [],
            }
        },
        created() {
            KeplerBackofficeSdk.clients.list(1, 1000, {id: this.$route.params.id}).paymentMethods((data) => {
                this.paymentMethods = data.items
            })
        },

        methods: {
            refreshList() {
                return this.$refs.wrList.loadData(1)
            },
            dataLoader(callback, page, resultsPerPage) {
                return KeplerBackofficeSdk.wallets.list(page, resultsPerPage).records(this.value.id, (data) => {
                    callback(data)
                })
            },
        },
        computed: {
            search() {
                return {
                    wallet_id: this.value.id
                }
            }
        },
        props: ['value']
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// MultiWallet.vue?0182dbb0